export const USER_KEY = 'CoS_Auth';
